export default function Home() {
  const isMobile = window.innerWidth <= 768;
  const isSmallMobile = window.innerWidth <= 480;

  return (
    <div style={{
      padding: isSmallMobile ? '2rem 1rem' : isMobile ? '3rem 1.5rem' : '4rem 2rem',
      maxWidth: '1200px',
      margin: '0 auto',
      height: '100%',
      overflow: 'auto',
      boxSizing: 'border-box'
    }}>
      <h1 style={{
        fontSize: isSmallMobile ? '2rem' : isMobile ? '2.5rem' : '3rem',
        marginBottom: '1rem',
        lineHeight: 1.2
      }}>
        DayZ Script Documentation
      </h1>
      <p style={{
        fontSize: isSmallMobile ? '1rem' : isMobile ? '1.1rem' : '1.25rem',
        marginBottom: '2rem',
        opacity: 0.8
      }}>
        A community driven coding resource.
      </p>

      <div style={{
        display: 'grid',
        gridTemplateColumns: isSmallMobile ? '1fr' : 'repeat(auto-fit, minmax(280px, 1fr))',
        gap: isSmallMobile ? '1.5rem' : '2rem',
        marginTop: isSmallMobile ? '2rem' : '3rem'
      }}>
        <div style={{
          padding: isSmallMobile ? '1.5rem' : '2rem',
          background: 'var(--card-bg)',
          borderRadius: '0.5rem',
          boxShadow: 'var(--shadow)'
        }}>
          <h3 style={{
            marginBottom: '1rem',
            fontSize: isSmallMobile ? '1.1rem' : '1.25rem'
          }}>📚 Class Browser</h3>
          <p style={{ marginBottom: '1rem' }}>
            Browse all DayZ classes with full inheritance trees and member information.
          </p>
          <a href="/docs-spa" style={{ color: 'var(--primary-color)', fontWeight: 600 }}>
            Browse Classes →
          </a>
        </div>
      </div>
    </div>
  );
}
